import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";

const ROSTER_QUERY_ROOTS = [
  QueryKeys.Students,
  QueryKeys.UsersScrollGet,
  QueryKeys.UserGet,
  QueryKeys.UserStudentsGet,
] as const;

/** Student lists plus parent views that embed linked children. */
export async function invalidateStudentRosterQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all(
    ROSTER_QUERY_ROOTS.map((key) =>
      queryClient.invalidateQueries({ queryKey: [key], refetchType: "all" }),
    ),
  );
}
